import i18next from 'i18next';
import React from 'react';

export const LABEL = {
  label: <div className="select-label">{i18next.t('CreditSimulation:quantity')}</div>,
  value: 'label',
  isDisabled: true
};
